import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Observable, Subject, Subscription} from "rxjs";

import {CloudApiService} from "../../services/cloud-api.service";
import {AuthenticationService} from "../../services/authentication.service";
import {UserSessionService} from "../../services/user-session.service";
import {CreateLicenceRequestDto} from "../../services/dtos/licencing/create-licence-request.dto";
import {CreateLicenceResponseDto} from "../../services/dtos/licencing/create-licence-response.dto";
import {AutocompleteValuesDto} from "../../services/dtos/licencing/autocomplete-values.dto";

@Component({
    selector: 'licence-management',
    template: require('./licence-management.component.html'),
    styles: [ require('./licence-management.component.css') ]
})
export class LicenceManagementComponent implements OnInit, OnDestroy {

    errorMessage: string;
    isLoadingInital: boolean;
    isLoading: boolean;

    autocompleteValues: AutocompleteValuesDto;
    createLicenceRequest: CreateLicenceRequestDto;
    createLicenceResponse: CreateLicenceResponseDto;

    licenceCode: string;

    private librarySubscription: Subscription;

    @ViewChild('requestCode') requestCodeTextArea: ElementRef;
    @ViewChild('licenceCode') licenceCodeTextArea: ElementRef;

    focusDistributor$ = new Subject<string>();
    focusCountry$ = new Subject<string>();
    focusLibraryName$ = new Subject<string>();
    focusDeviceUse$ = new Subject<string>();

    constructor(
      public userSession: UserSessionService,
      private authenticationService: AuthenticationService,
      private cloudApiService: CloudApiService,
      private modalService: NgbModal
    ) {}

    ngOnInit(): void {
        this.librarySubscription = this.userSession.library.subscribe(library => {
        });

        this.autocompleteValues = new AutocompleteValuesDto();
        this.createLicenceRequest = new CreateLicenceRequestDto();
        this.createLicenceResponse = new CreateLicenceResponseDto();
        this.licenceCode = '';

        this.loadAutocompleteValues();
    }

    public ngOnDestroy(): void {
        this.librarySubscription.unsubscribe();
    }

    loadAutocompleteValues(): void {
        this.isLoadingInital = true;
        this.cloudApiService.licencingGetAutocompleteValues().subscribe(
          response => { this.autocompleteValues = response; },
          error => { this.errorMessage = error; },
          () => { this.isLoadingInital = false; }
        );
    }

    selectRequestCodeText() { this.requestCodeTextArea.nativeElement.select(); }
    selectLicenceCodeText() { this.licenceCodeTextArea.nativeElement.select(); }

    pasteRequestCode() {
        // This doesn't work, replace with navigator.clipboard.readtext() after upgrade
        this.requestCodeTextArea.nativeElement.focus();
        document.execCommand('paste');
    }

    copyLicenceCode(): void {
        this.selectLicenceCodeText();
        document.execCommand('copy');
    }

    loadRequestCode(): void {
        this.createLicenceRequest.licenceRequestCode = 'value from file';
    }

    saveLicenceCode(): void {
        // Save to file
        //this.createLicenceResponse.licenceCode;
    }

    fieldIsValid(value: string) {
        return value !== undefined && value !== null && value !== '' && value !== 'undefined';
    }

    createLicence(): void {
        this.errorMessage = '';

        if (this.isLoading)
            return;

        if (
          !this.fieldIsValid(this.createLicenceRequest.licenceRequestCode) ||
          !this.fieldIsValid(this.createLicenceRequest.distributor) ||
          !this.fieldIsValid(this.createLicenceRequest.country) ||
          !this.fieldIsValid(this.createLicenceRequest.libraryName) ||
          !this.fieldIsValid(this.createLicenceRequest.deviceUse)
        ) {
            this.errorMessage = "All fields must be complete";
            return;
        }

        try {
            this.isLoading = true;
            this.createLicenceResponse.LicenceCode = '';

            this.cloudApiService.licencingCreateLicence(this.createLicenceRequest).subscribe(
              response => { this.createLicenceResponse.LicenceCode = response.LicenceCode; },
              error => { this.errorMessage = error; this.isLoading = false; },
              () => { setTimeout(() => { this.isLoading = false; }, 1000); }
            );
        } catch (Error) {
            this.errorMessage = Error.errorMessage;
        }
    }

    autocompleteDistributor = (text$: Observable<string>) => this.autocomplete(text$, this.focusDistributor$, () => this.autocompleteValues.Distributors);
    autocompleteCountry = (text$: Observable<string>) => this.autocomplete(text$, this.focusCountry$, () => this.autocompleteValues.Countries);
    autocompleteLibraryName = (text$: Observable<string>) => this.autocomplete(text$, this.focusLibraryName$, () => this.autocompleteValues.LibraryNames);
    autocompleteDeviceUse = (text$: Observable<string>) => this.autocomplete(text$, this.focusDeviceUse$, () => this.autocompleteValues.DeviceUse);

    autocomplete(text$: Observable<string>, focus$: Subject<string>, values: () => string[]) {
        const debouncedText$ = text$.debounceTime(200).distinctUntilChanged();
        const inputFocus$ = focus$.debounceTime(200);

        //return debouncedText$.merge(inputFocus$)
        return debouncedText$
          .map(term => (term === '' ? values()
            : values().filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/licence-mangement/licence-management.component.ts